export { default as FavoriteEmptyState } from './favorite-empty-state';
